import React from 'react';
import AssetImages from '../constants/images';
import '../constants/AssetsCss';
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GetORPostAsync from '../constants/restservice';
import withRouter from '../constants/withRouter';

const PackAmounts = [3000, 5000, 10000];
class BuyPackage extends React.Component {
    constructor(props) {
        super(props);
        this.PurchasePackage = this.PurchasePackage.bind(this);
        this.previousProgress = false;
    }
    async PurchasePackage(pid) {
        if (!this.previousProgress) {
            this.previousProgress = true;
            let json = {
                package: PackAmounts[pid - 1]
            };
            let res = await GetORPostAsync("buycontractConfirm.asp", "POST", JSON.stringify(json), localStorage.getItem("token"));
            if (res.status === "error") {
                toast(res.message);
                this.previousProgress = false;
                if (res.message === "Session Expired") {
                    this.props.history.push({
                        pathname: "/"
                    });
                }
                return;
            }
            swal({
                text: "Are you sure want to purchase this package.",
                title: "Package Amount : " + PackAmounts[pid - 1],
                icon: AssetImages.logo,
                buttons: ["Cancel", "Confirm"],
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.confirmPurchase(pid);
                    } else {
                        this.previousProgress = false;
                    }
                });
        } else {
            toast("Previous purchase on progress");
        }

    }
    async confirmPurchase(pid) {
        let json = {
            package: PackAmounts[pid - 1]
        };
        let res = await GetORPostAsync("buycontract.asp", "POST", JSON.stringify(json), localStorage.getItem("token"));
        if (res.status === "error") {
            toast(res.message);
            this.previousProgress = false;
            if (res.message === "Session Expired") {
                this.props.history.push({
                    pathname: "/"
                });
            }
            return;
        }
        toast(res.message);
        this.previousProgress = false;
    }
    render() {
        return (<div><div className="page-header">
            <div className="page-leftheader">
                <h4 className="page-title mb-0">Hi! {localStorage.getItem('fullname')}</h4>
                {/* <ol className="breadcrumb">
                    <li className="breadcrumb-item"><label><i className="fe fe-home mr-2 fs-14"></i>Main</label></li>
                    <li className="breadcrumb-item active" aria-current="page"><label>Buy Package</label></li>
                </ol> */}
            </div>
        </div>
            <div className="row">
                {
                    PackAmounts.map((item, index) => <div key={index} className={`card col-lg-3 col-md-12 border-top-color-${index % 2 === 0 ? "1" : "5"}`}>
                        <div className="card-body">

                            <div className={`card card-body bg-color-${index % 2 === 0 ? "1" : "3"}  mb-2`}>
                                <div className="media">
                                    <div className="media-body">
                                        <h3 className="font-25 text-center" style={{ color: "white" }}>{item}</h3>
                                    </div>
                                </div>
                            </div>
                            <div onClick={e => this.PurchasePackage(index + 1)} className={`card card-body bg-color-${index % 2 === 0 ? "1" : "3"} mt-5 mb-2`} style={{ color: "white" }}><label className="text-center fs-18"><i className="fe fe-shopping-cart mr-2 fs-20"></i> BUY </label> </div>
                        </div>
                    </div>)
                }
            </div>
        </div>
        );
    }
}

export default withRouter(BuyPackage);